import { useQuery } from "react-query";
import { NewsletterLifecycleMailService } from "../../../services/newsletter/newsletterLifecycleMail.service";
export var useLifecycleMailFilterOptions = function () {
    return useQuery('lifecycleMailFilterOptions', NewsletterLifecycleMailService.getFilterOptions, {
        // 10 minutes
        staleTime: 10 * 60 * 1000
    });
};
